/**
 * YabanciKatilimciSahaDisiNotu.jsx — Yabancı Katılımcı portalında "kurulum / söküm sürelerinde alana kimse gelmeyecekse bu platformda
 * yapmanız gereken bir işlem yok" notu (backlog #558, Deniz 2026-10-28; metin Bilge'nin "Tutorial Özeti"ndeki Onay Ekranı metnine göre
 * düzeltildi, 2026-10-30).
 *
 * Personeli yalnızca fuar açıkken gelen bir yabancı katılımcının FDS'de yapacağı bir şey yoktur: belge yok, personel listesi yok.
 * Not bunu en baştan söyler, böylece gereksiz yükleme yapmaz. Yalnızca BİLGİLENDİRİR, hiçbir şeyi kapatmaz: alanda kuruluma /
 * söküme gelecek kişisi olan firma kaydını buradan yapar ve her zamanki gibi devam eder.
 * "?" cümlesi yalnızca kullanım turu gerçekten açıkken (Kayıt Ayarları anahtarı açık, gerçek Katılımcı girişi) yazılır: üstteki "?"
 * düğmesi yoksa ona yönlendirmez.
 *
 * Kapsam bilerek YALNIZCA etkin arayüz seti Yabancı Katılımcı iken (yabanciKatilimciMi): Yerli setler ve dekoratörler (kurulumda
 * alandadır) görmez; personel girişinde portal bağlamı olmadığı için zaten çıkmaz, "firma olarak önizle" ise firmanın gördüğünü görür.
 * Her görüntülendiği yerde hep görünür (kapatma düğmesi / hatırlama yok — #558 soru 3, varsayılan).
 *
 * Kullanan yerler: FirmaAnasayfaListPage (Anasayfa), FirmaPersonelListPage (Personel listesi), FirmaKartPage (Evraklar sekmesi).
 */
import React, { useEffect, useState } from "react";
import { Alert } from "reactstrap";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { usePortal } from "../Contexts/PortalContext";
import { yabanciKatilimciMi } from "../Kisi/YabanciKatilimciParcalari";
import { getPortalEgitimAcik } from "../../services/systemSettingsService";
import { egitimGorebilir } from "../../services/egitimTuru";

export default function YabanciKatilimciSahaDisiNotu({ className = "mb-3" }) {
  const { t } = useTranslation("components");
  const portal = usePortal();
  // #704: bilerek sadePanelMi DEĞİL: not, Yabancı Katılımcı'nın BELGE kuralını anlatır; Sade panel modunda Yerli firmaya söylenmez.
  const goster = yabanciKatilimciMi(portal);
  const turuVar = goster && egitimGorebilir(portal);
  const [egitimAcik, setEgitimAcik] = useState(false);

  // KURAL: fetch Effect içindeki async fonksiyonda (react-hooks/set-state-in-effect). Okunamazsa KAPALI: "?" cümlesi yazılmaz.
  useEffect(() => {
    let ignore = false;
    async function run() {
      const acik = await getPortalEgitimAcik();
      if (!ignore) setEgitimAcik(acik);
    }
    if (turuVar) run();
    return () => { ignore = true; };
  }, [turuVar]);

  if (!goster) return null;
  return (
    <Alert color="info" className={`d-flex align-items-start gap-2 ${className}`} data-testid="yabanci-saha-disi-notu">
      <Info size={18} className="flex-shrink-0 mt-1" aria-hidden="true" />
      <div>
        {t("yabanciKatilimciSahaDisiNotu.metin")}{" "}
        {turuVar && egitimAcik && <>{t("yabanciKatilimciSahaDisiNotu.soruIsareti")}{" "}</>}
        <strong>{t("yabanciKatilimciSahaDisiNotu.dilek")}</strong>
      </div>
    </Alert>
  );
}
